import React, { useState } from 'react';
import SlotReel from './SlotReel';
import imageData from '../imageData';
import './SlotMachine.css';
import { useWallet } from '@solana/wallet-adapter-react';
import { WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import { Connection, PublicKey, Transaction, SystemProgram } from '@solana/web3.js';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../firebase';
import TransactionList from "./TransactionList";
import { doc, setDoc } from 'firebase/firestore';
import PoemMinter from "./PoetryMinter";
import HersoidPresentsWhite from '../images/HersoidPresentsWhite.png';
import HersoidPresentsBlack from '../images/HersoidPresentsBlack.png';
import ShlotMachineImage from '../images/ShlotMachineGraphicTransparentBackground.png';

const SlotMachine = () => {
    const [reels, setReels] = useState([imageData[0], imageData[0], imageData[0]]);
    const [spinning, setSpinning] = useState(false);
    const [winMessage, setWinMessage] = useState('');
    const [transactionSignature, setTransactionSignature] = useState('');
    const [transactionStatus, setTransactionStatus] = useState('');
    const { publicKey, sendTransaction } = useWallet();
    const [totalScore, setTotalScore] = useState('');
    const [showPoemMinter, setShowPoemMinter] = useState(false);

    const endpoint = process.env.REACT_APP_RPC_ENDPOINT;

    const connection = new Connection(
        endpoint,
        'confirmed'
    );
    const receiverAddress = 'DUx5zXMF1LdnX3Y8fsZSHamBbiNY4vJE4UaP8hRVeHRn';
    const amountRequired = 0.01;

    const getRandomImage = () => {
        const weightedImages = [];
        imageData.forEach(image => {
            for (let i = 0; i < image.rarity; i++) {
                weightedImages.push(image);
            }
        });
        const randomIndex = Math.floor(Math.random() * weightedImages.length);
        return weightedImages[randomIndex];
    };

    const getRandomImageSubset = (size = 5) => {
        const shuffledImages = [...imageData].sort(() => 0.5 - Math.random());
        return shuffledImages.slice(0, size);
    };

    const payAndSpin = async () => {
        // Reset messages and states
        setWinMessage('');
        setTransactionSignature('');
        setTransactionStatus('Pending');
        setSpinning(false);

        // if (!publicKey) {
        //     setWinMessage('Please connect your wallet first!');
        //     return;
        // }

        // let signature;
        // try {
            // Step 1: Create and send the transaction
            // const transaction = new Transaction().add(
            //     SystemProgram.transfer({
            //         fromPubkey: publicKey,
            //         toPubkey: new PublicKey(receiverAddress),
            //         lamports: amountRequired * 10 ** 9,
            //     })
            // );

            // signature = await sendTransaction(transaction, connection);
            // setTransactionSignature(signature);
            // setTransactionStatus('Pending');

            // const transactionDocRef = doc(db, 'shlot_pulls', signature);

            // await setDoc(transactionDocRef, {
            //     publicKey: publicKey.toBase58(),
            //     timestamp: new Date().toISOString(),
            //     transactionId: signature,
            //     transactionLink: `https://solscan.io/tx/${signature}?cluster=mainnet`,
            //     transactionStatus: 'Pending',
            //     totalScore: null,
            //     matchResult: null,
            //     results: [],
            // });

        //     setWinMessage('Transaction pending. Waiting for confirmation...');
        //     await connection.confirmTransaction(signature, 'confirmed');
        //     setTransactionStatus('Succeeded');
        //     setWinMessage('Payment successful! Spinning now...');
        // } catch (error) {
        //     console.error('Payment failed:', error);
        //
        //     if (signature) {
        //         const transactionDocRef = doc(db, 'shlot_pulls', signature);
        //         await setDoc(transactionDocRef, {
        //             publicKey: publicKey.toBase58(),
        //             timestamp: new Date().toISOString(),
        //             transactionId: signature,
        //             transactionLink: `https://solscan.io/tx/${signature}?cluster=mainnet`,
        //             transactionStatus: 'Failed',
        //             totalScore: null,
        //             matchResult: null,
        //             results: [],
        //         });
        //     }
        //
        //     setTransactionStatus('Failed');
        //     setWinMessage('Payment failed. Please try again.');
        //     return;
        //  }

        // Spin logic
        setSpinning(true);
        const spinDuration = 2000; // Duration for spinning reels
        const finalImages = [getRandomImage(), getRandomImage(), getRandomImage()];
        const reelIntervals = [];

        finalImages.forEach((finalImage, index) => {
            const reelSubset = getRandomImageSubset(10);
            let position = 0;

            const interval = setInterval(() => {
                position = (position + 1) % reelSubset.length;
                setReels((prevReels) => {
                    const newReelsState = [...prevReels];
                    newReelsState[index] = reelSubset[position];
                    return newReelsState;
                });
            }, 100); // Speed of spinning (in ms)

            reelIntervals.push(interval);

            setTimeout(() => {
                clearInterval(interval);

                // Use an async IIFE (Immediately Invoked Function Expression) here
                (async () => {
                    setReels((prevReels) => {
                        const newReelsState = [...prevReels];
                        newReelsState[index] = finalImage;
                        return newReelsState;
                    });

                    if (index === finalImages.length - 1) {
                        setSpinning(false);

                        const totalScore = finalImages.reduce((acc, img) => acc + img.score, 0);
                        setTotalScore(totalScore);
                        const isWin = finalImages.every((img) => img.text === finalImages[0].text);
                        const matchResult = isWin ? 'Win' : 'Loss';
                        setWinMessage(isWin ? '🎉 Jackpot! You Win! 🎉' : 'You Lost! Try Again!');
                        // setShowPoemMinter(true);
                        // const transactionDocRef = doc(db, 'shlot_pulls', signature);

                        // Update transaction with final results
                        // try {
                        //     await setDoc(transactionDocRef, {
                        //         publicKey: publicKey.toBase58(),
                        //         timestamp: new Date().toISOString(),
                        //         transactionId: signature,
                        //         transactionLink: `https://solscan.io/tx/${signature}?cluster=mainnet`,
                        //         transactionStatus: 'Succeeded',
                        //         totalScore,
                        //         matchResult,
                        //         results: finalImages.map((img) => ({
                        //             name: img.text || 'Unknown',
                        //             score: img.score || 0,
                        //             rarity: img.rarity || 0,
                        //         })),
                        //     }, { merge: true });
                        //     console.log('Pull data updated successfully!');
                        // } catch (error) {
                        //     console.error('Error updating pull data:', error);
                        // }
                    }
                })(); // End of IIFE
            }, spinDuration + index * 300); // Staggering stop times for each reel
        });
    };


    return (

        <>
        {/*<div>*/}
        {/*    <img className="slot-title-image" src={HersoidPresentsBlack} alt="Hersoid Presents"/>*/}
        {/*    <div className="lobster-title-container">*/}
        {/*        <h1 className="lobster-title">The Shitface Shlot Machines</h1>*/}
        {/*    </div>*/}
        {/*</div>*/}

        <div className="slot-machine">


            {/*{publicKey && <p>Connected Wallet: {publicKey.toBase58()}</p>}*/}


            <div className="slot-machine-image-overlay">
                <img className="slot-machine-image" src={ShlotMachineImage} alt="Shlot Machine"/>
            <div className="reels-container">
                <div className="reels">

                    {/*{reels.map((image, index) => (*/}
                    {/*    <SlotReel*/}
                    {/*        key={index}*/}
                    {/*        image={image}*/}
                    {/*        spinning={spinning}*/}
                    {/*    />*/}
                    {/*))}*/}
                    {!showPoemMinter ? (
                        <div className="reels">
                            {reels.map((image, index) => (
                                <SlotReel
                                    key={index}
                                    image={image}
                                    spinning={spinning}
                                />
                            ))}
                        </div>
                    ) : (
                        <div style={{ textAlign: 'center', marginTop: '1rem' }}>
                            <PoemMinter
                                slots={reels}
                                matchResult={transactionStatus === 'Succeeded'
                                    ? winMessage.includes("Jackpot") ? 'Win' : 'Loss'
                                    : 'Pending'}
                            />
                        </div>
                    )}

                </div>
                <div className='button-results-container'>
                    <div className='pay-and-spin-button-container'>
                        {winMessage && <p className="win-message">{winMessage}</p>}
                        {totalScore && !spinning && <h1>Total Score: {totalScore}</h1>}
                        <div>
                        <div>
                        {!showPoemMinter && (
                        <button className='pay-and-spin-button' onClick={payAndSpin} disabled={spinning}>
                            {spinning ? 'Processing...' : 'Spin Shlots'}
                            {/*{totalScore && <p>Total Score: {totalScore}</p>}*/}
                        </button>

                                )}
                        </div>
                        <div>
                        {!spinning && !showPoemMinter && (
                            <button
                                className="generate-poem-button"
                                onClick={() => setShowPoemMinter(true)}
                                style={{ marginTop: '1rem' }}
                            >
                                View Your Degenerated Poetry
                            </button>
                        )}
                        </div>
                        </div>
                        {showPoemMinter && (
                            <button
                                className="back-to-reels-button"
                                onClick={() => setShowPoemMinter(false)}
                                style={{ marginTop: '1rem' }}
                            >
                                Spin the Reels Again!
                            </button>
                        )}
                    </div>


                    {/*{transactionSignature && (*/}
                    {/*    <p>*/}
                    {/*        Transaction Status: <strong>{transactionStatus}</strong>*/}
                    {/*        <br />*/}
                    {/*        View transaction on Solscan: <a href={`https://solscan.io/tx/${transactionSignature}?cluster=mainnet`} target="_blank" rel="noreferrer">*/}
                    {/*        {`https://solscan.io/tx/${transactionSignature}?cluster=mainnet`}*/}
                    {/*    </a>*/}
                    {/*    </p>*/}
                    {/*)}*/}
                </div>
            </div>
            </div>

            {/*<div className="slot-controls">*/}
            {/*    <div className="slot-title">*/}

            {/*        <div className="lobster-title-container">*/}
            {/*            <h1 className="lobster-title">Spin the Shlots</h1>*/}
            {/*        </div>*/}

            {/*    </div>*/}
                {/*<div className="shlot-machine-instructions">*/}
                {/*    <h3>Spin the Shlots</h3>*/}
                {/*    <p>Can you top the leader board?</p>*/}
                {/*    <p>Each shitface carries a score based on rarity.</p>*/}
                {/*    <p>Top scores each week win wonderful digital prizes.</p>*/}
                {/*    <p>Absolutely no cash prizes!</p>*/}
                {/*    <p>But super dynamically created degenerate poetry with every spin!</p>*/}
                {/*</div>*/}


            {/*<div className="poetry-minter-container">*/}
            {/*{!spinning && reels[0] && (*/}
            {/*    <PoemMinter*/}
            {/*        // isQRVisible = true*/}
            {/*        slots={reels}*/}
            {/*        matchResult={transactionStatus === 'Succeeded' ?*/}
            {/*            (winMessage.includes("Jackpot") ? 'Win' : 'Loss') : 'Pending'} />*/}
            {/*)}*/}
            {/*</div>*/}


        {/*</div>*/}

        </div>
</>

    );
};

export default SlotMachine;
